function switchFav(id, isFav) {
  var favStr = readCookie('fav');
  var favs = (favStr ? favStr.split(',') : new Array());
  if (isFav == 'true') {
    favs.splice(favs.indexOf(id), 1);
    btn.data('fav', 'false');
  }
  else {
    if ($.inArray(id, favs) < 0) {
      favs.push(id);
      btn.data('fav', 'true');
    }
  }
  createCookie('fav', favs.join(), 7);
  //$('#favCount').html(favs.length);
  $( ".favCount" ).each(function() {
    $( this ).html(favs.length);
  });
}

$(function(){
  $(document).on('click', '.favBtn', function(e) {
    var that = $(this),
    id = that.data('cottage').toString(),
    favStr = readCookie('fav'),
    favs = (favStr ? favStr.split(',') : new Array()),
    favPosition = favs.indexOf(that.data('cottage').toString()),
    favValid = favPosition > -1,
    length = 0,
    parent = that.parent(),
    shortIcon = parent.find('.favAddedBlock').length > 0;

    //remove
    if (that.attr('data-fav') == 'remove'){
      if (favValid){
        delete favs[favPosition];
        favs.splice(favPosition, 1);
        that.attr('data-fav', 'add');
        that.removeClass('active');
        that.html(that.data('str-add'));
      }
    }
    //add
    else{
      if (!favValid){
        favs.push(id);
        that.attr('data-fav', 'remove');
        that.addClass('active');
        that.html(that.data('str-remove'));
      }
    }

    //deal with animation for cottages search page
    if (shortIcon){
      var cibling = parent.find('.favAddedBlock'),
      text = that.attr('data-fav') == 'remove' ? cibling.data('str-add') : cibling.data('str-remove');
      cibling.text(text).addClass('favAdded');
      setTimeout(function() {
        cibling.removeClass( "favAdded" );
      }, 2000);
    }

    length = favs.join() == '' ? 0 : favs.length;
    
    createCookie('fav', favs.join(), false);

    //$('#favCount').html(length);
    $( ".favCount" ).each(function() {
      $( this ).html(length);
    });

    if (that.data('reload')){
      // window.location.reload();
    }
  });
});
